import { isNumber } from '@lib/generic.utils'

export const rerenderOnIdChange = (idName = 'id') => ({
  watch: {
    [idName](newVal, oldVal) {
      if (isNumber(newVal) && isNumber(oldVal) && Number(newVal) === Number(oldVal)) return
      this.$emit('rerender')
    }
  }
})

export const refreshOnIdChange = (idName = 'id') => ({
  watch: {
    [idName]() {
      this.$router.go()
    }
  }
})
